
  import { defineComponent, computed } from 'vue';
  import FilterButton from '@/ui/components/analytics/FilterButton.vue';
  import { useFilterConfiguration } from '@/ui/concerns/analytics/useFilters';
  import ReportExport from '@/ui/components/analytics/ReportExport.vue';
  import { SupportedExportFormat } from '@/services/api/resources/analytics';
  import { useExports } from '@/ui/concerns/analytics/exports/useExports';
  import { Button } from '@/ui/components/Button';
  import { useReportInjection } from '@/ui/concerns/analytics/useReportInjection';
  import { Tag } from '@/ui/components/Tag';

  interface AnalyticsBuilderOptionsProps {
    scheduleExists: boolean;
  }

  export default defineComponent<AnalyticsBuilderOptionsProps>({
    components: {
      FilterButton,
      ReportExport,
      Button,
      Tag,
    },
    props: ['scheduleExists'],
    setup() {
      const { isReportExportLoading, exportReport, publicExportReport } = useExports();
      const { isGuest, reportId, report } = useReportInjection();
      const { countFilters } = useFilterConfiguration();

      const reportFiltersCount = computed(() => {
        if (!report.value) {
          return 0;
        }

        return countFilters(report.value.filters);
      });

      const disableExport = computed(() => !reportId.value || report.value?.widgets?.length === 0);

      const onExport = (format: SupportedExportFormat) => {
        if (reportId.value) {
          isGuest ? publicExportReport(reportId.value, format).run() : exportReport(reportId.value, format).run();
        }
      };

      const showFilterButton = !isGuest || reportFiltersCount.value > 0;

      return {
        isGuest,
        reportId,
        reportFiltersCount,
        disableExport,
        isReportExportLoading,
        onExport,
        showFilterButton,
      };
    },
  });
